<template>
  <span>
    <v-app-bar prominent elevation="0" >
      <!--All but xs & sm-->
      <v-container
        class="v-app-bar-items d-none d-sm-flex.d-sm-none d-md-flex h-100"
        >
        <v-sheet class="h-100">
          <Logo class="h-100" />
        </v-sheet>
        <v-sheet class="h-100">
          <SearchBar class="h-100"  />
        </v-sheet>
        <v-sheet>
          <Tools  class="h-100" />
        </v-sheet>
      </v-container>
      <!--xs & sm-->
      <v-container
        class="d-flex d-sm-none d-none d-sm-flex d-md-none justify-space-between h-100 ma-0">
        <v-sheet class="h-100 pa-0 ma-0">
          <v-row class="pa-0 h-100 ma-0">
            <v-col class="pa-0 d-flex align-center h-100 ma-0">
              <v-sheet>
                <v-container class="fill-height pa-0">
                  <div>
                    <div
                      class="menu-wrapper"
                      @click="drawer = !drawer"
                      :class="{ active: drawer }"
                    >
                      <div class="menu-bar one bg-primary hamburger"></div>
                      <div class="menu-bar two bg-primary hamburger"></div>
                      <div class="menu-bar three bg-primary hamburger"></div>
                    </div>
                  </div>
                </v-container>
              </v-sheet>
            </v-col>
            <v-col class="h-100 pa-0 my-0 ml-3"
              ><v-sheet class="h-100">
                  <Logo class="h-100"/>
              </v-sheet>
            </v-col>
          </v-row>
        </v-sheet>
        <v-sheet>
          <Tools class="h-100"  />
        </v-sheet>
      </v-container>
    </v-app-bar>
    <!--xs & sm-->
    <v-navigation-drawer v-model="drawer" temporary class="drawer d-flex d-sm-none d-none d-sm-flex d-md-none justify-space-between">
      <Drawer />
    </v-navigation-drawer>
  </span>
</template>
<script setup>
import Logo from "@/components/App/logoLogo.vue";
import Tools from "@/components/App/BarTools.vue";
import SearchBar from "@/components/App/searchBar.vue";
import Drawer from "@/components/App/drawerDrawer.vue";


const route = useRoute();
const drawer = ref(false);
</script>
<style scoped>
.menu-wrapper {
  width: 21px;
  height: 19px;
  cursor: pointer;
  position: relative;
}

.menu-bar {
  position: absolute;
  width: 21px;
}

.one {
  top: 1px;
  animation-delay: 0.1s;
  transition: all 0.3s;
  height: 2px;
}

.two {
  top: 8px;
  transition: all 0.3s;
  height: 2px;
}
.three {
  top: 15px;
  transition: all 0.3s;
  height: 2px;
}

.active .one {
  top: 45%;
  left: 0%;
  transform: rotate(45deg);
}
.active .two {
  top: 45%;
  left: 0%;
  transform: rotate(-45deg);
}

.active .three {
  top: 45%;
  left: 0%;
  transform: rotate(-45deg);
}
</style>
